import { useEffect, useState } from "react"

import { Space, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Icon from "../Icon"

const { Text } = Typography

function PasswordValidator({
  value,
  error,
  isLogin = false,
  isSignup = false,
  setValidPass = null
}) {
  const { t } = useTranslation()
  const [text, setText] = useState(
    isLogin ? "At least 8 characters" : "Must be at least 8 characters"
  )
  const [errorText, setErrorText] = useState(null)
  const [custom, setCustom] = useState({ status: "", color: "" })

  const great = /^(?=.*[a-zA-Z])(?=.*[±!@#$%^&*()_+=;:'"|?/.,><`~])(?=.*[0-9]).{8,}$/
  const good1 = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}$/
  const good2 = /^(?=.*[a-zA-Z])(?=.*[±!@#$%^&*()_+=;:'"|?/.,><`~]).{8,}$/

  useEffect(() => {
    if (error && !isSignup) {
      if (typeof error === "string") {
        setErrorText(error)
      } else {
        setErrorText(
          error?.code === "token_not_valid"
            ? t("You have already created a password. Try to log in")
            : Object.values(error)[0]
        )
      }
    } else if (errorText) {
      setErrorText(false)
      checkValue(value)
    }
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [!!error])

  function defaultValue() {
    setText(isLogin ? "" : t("Must be at least 8 characters"))
    setCustom({ status: "", color: "" })
    if (isLogin && setValidPass) setValidPass(false)
  }

  useEffect(() => {
    value ? checkValue(value) : defaultValue()
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [value])

  function checkValue(val) {
    if (val) {
      if (val?.match(great)) {
        if (val?.length >= 8) {
          if (isLogin && setValidPass) setValidPass(true)
          setText(isLogin ? "" : t("Your password is outstanding!"))
          setCustom({ status: "Strong", color: "green" })
        }
      } else if (val?.match(good1) || val.match(good2)) {
        if (val?.length >= 8) {
          if (isLogin && setValidPass) setValidPass(true)
          //setText(isLogin ? '' : 'You can make it better!');
          setCustom({ status: "Good", color: "yellow" })
        }
      } else if (val?.length >= 8) {
        if (isLogin && setValidPass) setValidPass(true)
        //setText(isLogin ? '' : 'You can make it better!');
        setCustom({ status: "Good", color: "yellow" })
      } else {
        if (isLogin && setValidPass) setValidPass(false)
        setCustom({ status: "Weak", color: "red" })
        //setText(isLogin ? 'At least 8 characters' : 'Must be at least 8 characters');
      }
    }
  }

  return (
    <div
      id="psw-validator"
      className={cls(custom.color, {
        "login-password-validator": isLogin
      })}
    >
      {errorText ? (
        <Space size={4} className="error">
          {errorText && <Icon type={"alert_triangle_error"} />}
          {error?.code === "token_not_valid" ? (
            <span>
              {t("You have already created a password. Try to")} <a href="/login">{t("log in")}</a>
            </span>
          ) : (
            errorText || text
          )}
        </Space>
      ) : (
        <div className="wrap">
          {value ? (
            <>
              <div className="text-validator">{t(custom?.status)}</div>
              <div className="items-validator">
                <div />
              </div>
            </>
          ) : null}

          {!value ? (
            <Text type="secondary" style={{ lineHeight: 1.4 }}>
              {t("Use at least 8 characters, with mix of characters, numbers and letters.")}
            </Text>
          ) : null}
        </div>
      )}
    </div>
  )
}

export default PasswordValidator
